/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Empty_MoreInputs */

const en_practice_empty_more = /** @type {(inputs: Practice_Empty_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`for more information.`)
};

const es_practice_empty_more = /** @type {(inputs: Practice_Empty_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`para más info.`)
};

const de_practice_empty_more = /** @type {(inputs: Practice_Empty_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`für weitere Informationen.`)
};

const zh_practice_empty_more = /** @type {(inputs: Practice_Empty_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`了解更多信息。`)
};

const ar_practice_empty_more = /** @type {(inputs: Practice_Empty_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لمزيد من المعلومات.`)
};

const fr_practice_empty_more = /** @type {(inputs: Practice_Empty_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pour plus d'informations.`)
};

const vi_practice_empty_more = /** @type {(inputs: Practice_Empty_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`để biết thêm thông tin.`)
};

const sw_practice_empty_more = /** @type {(inputs: Practice_Empty_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kwa taarifa zaidi.`)
};

const th_practice_empty_more = /** @type {(inputs: Practice_Empty_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สำหรับข้อมูลเพิ่มเติม`)
};

const bs_practice_empty_more = /** @type {(inputs: Practice_Empty_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`za više informacija.`)
};

const ja_practice_empty_more = /** @type {(inputs: Practice_Empty_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`詳しくはこちら`)
};

const ko_practice_empty_more = /** @type {(inputs: Practice_Empty_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`더 많은 정보.`)
};

const pt_practice_empty_more = /** @type {(inputs: Practice_Empty_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`para mais informações.`)
};

const it_practice_empty_more = /** @type {(inputs: Practice_Empty_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`per ulteriori informazioni.`)
};

const sv_practice_empty_more = /** @type {(inputs: Practice_Empty_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`för mer information.`)
};

const nl_practice_empty_more = /** @type {(inputs: Practice_Empty_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`voor meer informatie.`)
};

const da_practice_empty_more = /** @type {(inputs: Practice_Empty_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`for mere information.`)
};

const nb_practice_empty_more = /** @type {(inputs: Practice_Empty_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`for mer informasjon.`)
};

const fi_practice_empty_more = /** @type {(inputs: Practice_Empty_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`saadaksesi lisätietoja.`)
};

const pl_practice_empty_more = /** @type {(inputs: Practice_Empty_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`aby uzyskać więcej informacji.`)
};

const ru_practice_empty_more = /** @type {(inputs: Practice_Empty_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`для получения дополнительной информации.`)
};

const tr_practice_empty_more = /** @type {(inputs: Practice_Empty_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daha fazla bilgi için.`)
};

const hi_practice_empty_more = /** @type {(inputs: Practice_Empty_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अधिक जानकारी के लिए।`)
};

const id_practice_empty_more = /** @type {(inputs: Practice_Empty_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`untuk informasi lebih lanjut.`)
};

const ms_practice_empty_more = /** @type {(inputs: Practice_Empty_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`untuk maklumat lanjut.`)
};

const cs_practice_empty_more = /** @type {(inputs: Practice_Empty_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pro více informací.`)
};

const el_practice_empty_more = /** @type {(inputs: Practice_Empty_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`για περισσότερες πληροφορίες.`)
};

const he_practice_empty_more = /** @type {(inputs: Practice_Empty_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`למידע נוסף.`)
};

const af_practice_empty_more = /** @type {(inputs: Practice_Empty_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vir meer inligting.`)
};

const hu_practice_empty_more = /** @type {(inputs: Practice_Empty_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`további információkért.`)
};

/**
* | output |
* | --- |
* | "for more information." |
*
* @param {Practice_Empty_MoreInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const practice_empty_more = /** @type {((inputs?: Practice_Empty_MoreInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Empty_MoreInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_practice_empty_more(inputs)
	if (locale === "de") return de_practice_empty_more(inputs)
	if (locale === "zh") return zh_practice_empty_more(inputs)
	if (locale === "ar") return ar_practice_empty_more(inputs)
	if (locale === "fr") return fr_practice_empty_more(inputs)
	if (locale === "vi") return vi_practice_empty_more(inputs)
	if (locale === "sw") return sw_practice_empty_more(inputs)
	if (locale === "th") return th_practice_empty_more(inputs)
	if (locale === "bs") return bs_practice_empty_more(inputs)
	if (locale === "ja") return ja_practice_empty_more(inputs)
	if (locale === "ko") return ko_practice_empty_more(inputs)
	if (locale === "pt") return pt_practice_empty_more(inputs)
	if (locale === "it") return it_practice_empty_more(inputs)
	if (locale === "sv") return sv_practice_empty_more(inputs)
	if (locale === "nl") return nl_practice_empty_more(inputs)
	if (locale === "da") return da_practice_empty_more(inputs)
	if (locale === "nb") return nb_practice_empty_more(inputs)
	if (locale === "fi") return fi_practice_empty_more(inputs)
	if (locale === "pl") return pl_practice_empty_more(inputs)
	if (locale === "ru") return ru_practice_empty_more(inputs)
	if (locale === "tr") return tr_practice_empty_more(inputs)
	if (locale === "hi") return hi_practice_empty_more(inputs)
	if (locale === "id") return id_practice_empty_more(inputs)
	if (locale === "ms") return ms_practice_empty_more(inputs)
	if (locale === "cs") return cs_practice_empty_more(inputs)
	if (locale === "el") return el_practice_empty_more(inputs)
	if (locale === "he") return he_practice_empty_more(inputs)
	if (locale === "af") return af_practice_empty_more(inputs)
	if (locale === "hu") return hu_practice_empty_more(inputs)
	return en_practice_empty_more(inputs)
});